




import Vue from 'vue';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import NewContainer from '@/containers/cv-section-date/new.vue';
import * as CvSectionDateStoreNew from '@/store/modules/cvSectionDateNew';

export default Vue.extend({
  components: {
    NewContainer,
  },
  mixins: [PageLeftHook],
  data() {
    return {
      storeList: [CvSectionDateStoreNew],
    };
  },
});
